/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date: Thu Apr 04 2024 14:26:36
 *
 *******************************************************/
// @flow

import type { Action } from './store.type';

export const UPDATE_SEARCH_PERSONALIZATION_REQUEST = 'UPDATE_SEARCH_PERSONALIZATION_REQUEST';
type UPDATE_SEARCH_PERSONALIZATION_REQUEST_TYPE = 'UPDATE_SEARCH_PERSONALIZATION_REQUEST';

export const UPDATE_SEARCH_PERSONALIZATION_SUCCESS = 'UPDATE_SEARCH_PERSONALIZATION_SUCCESS';
type UPDATE_SEARCH_PERSONALIZATION_SUCCESS_TYPE = 'UPDATE_SEARCH_PERSONALIZATION_SUCCESS';

export const UPDATE_SEARCH_PERSONALIZATION_FAILURE = 'UPDATE_SEARCH_PERSONALIZATION_FAILURE';
type UPDATE_SEARCH_PERSONALIZATION_FAILURE_TYPE = 'UPDATE_SEARCH_PERSONALIZATION_FAILURE';

export const GET_SEARCH_PERSONALIZATION_REQUEST = 'GET_SEARCH_PERSONALIZATION_REQUEST';
type GET_SEARCH_PERSONALIZATION_REQUEST_TYPE = 'GET_SEARCH_PERSONALIZATION_REQUEST';

export const GET_SEARCH_PERSONALIZATION_SUCCESS = 'GET_SEARCH_PERSONALIZATION_SUCCESS';
type GET_SEARCH_PERSONALIZATION_SUCCESS_TYPE = 'GET_SEARCH_PERSONALIZATION_SUCCESS';

export const GET_SEARCH_PERSONALIZATION_FAILURE = 'GET_SEARCH_PERSONALIZATION_FAILURE';
type GET_SEARCH_PERSONALIZATION_FAILURE_TYPE = 'GET_SEARCH_PERSONALIZATION_FAILURE';

export const TRIGGER_SYNC_SEARCH_PERSONALIZATION = 'TRIGGER_SYNC_SEARCH_PERSONALIZATION';
export const STOP_TRIGGER_SYNC_SEARCH_PERSONALIZATION = 'STOP_TRIGGER_SYNC_SEARCH_PERSONALIZATION';

// Check live theme supported
type SearchPersonalizationSuccess = {};
type SearchPersonalizationFailure = {
  error: any
};
type GetSearchPersonalizationRequestAction = Action<GET_SEARCH_PERSONALIZATION_REQUEST_TYPE, null>;

type GetSearchPersonalizationSuccessAction = Action<
  GET_SEARCH_PERSONALIZATION_SUCCESS_TYPE,
  SearchPersonalizationSuccess
>;

type GetSearchPersonalizationFailureAction = Action<
  GET_SEARCH_PERSONALIZATION_FAILURE_TYPE,
  SearchPersonalizationFailure
>;

type UpdateSearchPersonalizationRequestAction = Action<
  UPDATE_SEARCH_PERSONALIZATION_REQUEST_TYPE,
  null
>;

type UpdateSearchPersonalizationSuccessAction = Action<
  UPDATE_SEARCH_PERSONALIZATION_SUCCESS_TYPE,
  SearchPersonalizationSuccess
>;

type UpdateSearchPersonalizationFailureAction = Action<
  UPDATE_SEARCH_PERSONALIZATION_FAILURE_TYPE,
  SearchPersonalizationFailure
>;

export type SearchPersonalizationAction =
  | GetSearchPersonalizationRequestAction
  | GetSearchPersonalizationSuccessAction
  | GetSearchPersonalizationFailureAction
  | UpdateSearchPersonalizationRequestAction
  | UpdateSearchPersonalizationSuccessAction
  | UpdateSearchPersonalizationFailureAction;

export type SearchPersonalizationState = {
  loading: boolean,
  updating: boolean,
  settings: boolean,
  success: boolean,
  checkSyncSearchPersonalization: number,
  showSyncSuccess: boolean
};
